import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-y-small', 'IconLetterYSmall', [["path",{"d":"M10 8l2 5l2 -5","key":"svg-0"}],["path",{"d":"M12 16v-3","key":"svg-1"}]]);